import TamaraWidget from '../product/installments/Tamara';
import MadfuWidget from '../product/installments/Madfu';
import MISPayWidget from '../product/installments/MISPay';
import UseLocale from '@/hooks/useLocale';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

const TabbyWidget = dynamic(() => import('../product/installments/Tabby'), {
  ssr: false,
  loading: () => <div>Loading...</div>,
});

const InstallmentsWidgets = ({
  fromPDP = false,
  product,
  t,
  cartTotal = 0,
  page,
  tabbyTotal,
  deviceType = 'desktop', // used to render two tabby widgets on the same page
}) => {
  const { store } = UseLocale();
  const { locale } = useRouter();
  const total = fromPDP ? product?.prices_with_tax?.price : cartTotal;

  // const InstallmentComponent = ({ src }) => (
  //   <div className='flex gap-2 p-2 border rounded-md sm:items-center sm:justify-center'>
  //     <Image
  //       loading='lazy'
  //       src={src}
  //       className='object-contain w-10 h-7 sm:w-16'
  //       alt=''
  //     />
  //     <p className='text-xs leading-5 sm:text-[15px]'>
  //       {locale === 'en'
  //         ? 'Pay in 4 interest-free installments'
  //         : 'ادفع على 4 أقساط بدون فوائد'}{' '}
  //       <span className='font-bold'>
  //         {(total / 4).toFixed(2)} {t('SR')}.
  //       </span>{' '}
  //       {locale === 'en' ? 'Find out' : 'إكتشف'}
  //     </p>
  //   </div>
  // );

  return (
    <div
      // ${!fromPDP ? 'grid-cols-2' : 'grid-cols-1 md:grid-cols-2'}
      className='grid grid-cols-1 gap-2'
    >
      {fromPDP && (
        // product?.eligible_for_tabby &&
        <TabbyWidget
          t={t}
          locale={locale}
          total={tabbyTotal || total}
          fromPDP={fromPDP}
          page={page}
          deviceType={deviceType}
        />
      )}
      {fromPDP && store === 'ksa' && (
        //product?.eligible_for_tamara &&
        <TamaraWidget t={t} locale={locale} total={total} fromPDP={fromPDP} />
      )}
      {fromPDP && store === 'ksa' && <MISPayWidget total={total} />}
      {/* {fromPDP && (
        <MadfuWidget />
      )} */}
      {store === 'ksa' && (
        <div className='col-span-full'>
          <MadfuWidget fromPDP={fromPDP} />
        </div>
      )}
      {!fromPDP && (
        <TabbyWidget
          t={t}
          locale={locale}
          total={tabbyTotal || total}
          page={page}
          deviceType={deviceType}
        />
      )}
      {!fromPDP && store === 'ksa' && (
        <TamaraWidget t={t} locale={locale} total={total} />
      )}
      {!fromPDP && store === 'ksa' && <MISPayWidget total={total} />}
      {/* {!fromPDP && <MadfuWidget />} */}
    </div>
  );
};

export default InstallmentsWidgets;
